import React from "react";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { changeLanguageProps as Props } from "../../types/index";

const FormLanguageInput: React.FC<Props> = ({
  applyLanguages,
  onInputChange,
}) => {
  return (
    <React.Fragment>
      {Array.isArray(applyLanguages) && applyLanguages.length > 0 && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
          }}
        >
          <FormControl
            sx={{ m: { xs: 0, sm: 3 }, ml: { xs: 0, sm: 0, md: 0 } }}
            component="fieldset"
            variant="standard"
          >
            <FormLabel
              component="legend"
              sx={{
                fontFamily: "Avenir",
                letterSpacing: "0px",
                color: "#333333",
                opacity: 0.6,
                fontSize: { xs: "14px", sm: "16px", md: "19px", xl: "20px" },
                lineHeight: { xs: "20px", sm: "22px", md: "27px", xl: "27px" },
                mb: "4px",
                "&.Mui-focused": {
                  color: "#333333",
                },
              }}
            >
              Please select all that apply
            </FormLabel>
            <FormGroup>
              {applyLanguages.map((item, i) => (
                <FormControlLabel
                  key={i}
                  control={
                    <Checkbox
                      checked={item.status}
                      name={item.id.toString()}
                      onChange={onInputChange}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        fontFamily: "Avenir",
                        letterSpacing: "0px",
                        color: "#333333",
                        opacity: 1,
                        fontSize: {
                          xs: "14px",
                          sm: "16px",
                          md: "18px",
                          xl: "24px",
                        },
                        lineHeight: {
                          xs: "20px",
                          sm: "22px",
                          md: "26px",
                          xl: "33px",
                        },
                        width: "77%",
                        justifyContent: "center",
                      }}
                    >
                      {item.name}
                    </Typography>
                  }
                  sx={{
                    background: "#2685F826",
                    border: "1px solid #2685F899",
                    borderRadius: "10px",
                    opacity: 1,
                    width: {
                      xs: "220px",
                      sm: "223px",
                      md: "223px",
                      xl: "291px",
                    },
                    height: { xs: "40px", sm: "44px", md: "44px", xl: "58px" },
                    marginBottom: "10px",
                    marginLeft: 0,
                    color: "#333333",
                    display: "inline-flex",
                  }}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Box>
      )}
    </React.Fragment>
  );
};

export default FormLanguageInput;
